import { useParams } from 'react-router';

import { useSchemaHashParams } from '../useSchemaHashParams.ts';
import { webhookSchema } from '../webhookSchema.ts';

import { WebhookObjectSchemaPage } from './WebhookObjectSchemaPage.tsx';

import { OopsPage } from '#src/App/OopsPage.tsx';
import { isObjectType } from '#src/utils/jsonSchema.ts';

export const WebhookSchemaPage = () => {
  const { definitionName } = useParams();
  const { propertyName } = useSchemaHashParams();

  const type = webhookSchema.definitions[definitionName ?? ''];
  if (!type || !isObjectType(type) || !definitionName) {
    return <OopsPage />;
  }

  return (
    <WebhookObjectSchemaPage
      heading={definitionName}
      objectName={definitionName}
      objectType={type}
      propertyName={propertyName}
    />
  );
};
